module.exports = __webpack_public_path__ + "img/I-Suppose-You-Could-Say-That.27394cea.jpg";